import { html } from 'lit-element';
import { TmnConfirmationToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';

class ConfirmBulkSaveBtn extends TmnConfirmationToolBase {
    constructor() {
        super();
        this.disabled = false;
        //this.buttonColor = 'info';
        //this.controlType = 'icon-button';
        this.actionLabel = 'Update';
        this.itemType = 'user';
    }

    static get properties() {
        return {
            disabled: {
                type: Boolean,
            },
            count: {
                type: Number,
            },
            eventData: {
                type: Object,
            },
            actionLabel: {
                type: String,
            },
            itemType: {
                type: String,
            },
        };
    }

    getButtonLabel() {
        return html`${this.actionLabel} selected`;
    }

    getToolTitle() {
        return html`${this.actionLabel} selected`;
    }

    getConfirmationLabel() {
        const { count, actionLabel, itemType } = this;
        return `Are you sure want to ${actionLabel.toLowerCase()} ${count} ${itemType}s?`;
    }

    renderButton() {
        return html`<tmn-button
            .disabled=${this.disabled}
            @click=${this._toggleDialog}
            .eventData=${this.eventData}
            variant="outlined">
            <slot></slot
        ></tmn-button>`;
    }

    _handleConfirm(e) {
        // could pass in actions as an alternative
        const { eventData = {} } = this;
        this._toggleDialog();
        const event = new CustomEvent('bulk-save-confirmed', {
            detail: {
                ...eventData,
            },
        });
        this.dispatchEvent(event);
    }
}

window.customElements.define('confirm-bulk-save-btn', ConfirmBulkSaveBtn);
